import {
  DetailsTabs,
  ITicketDescriptionForm,
  ITicketDetails,
  TicketActionItem,
  TicketDetailsState,
} from "app/containers/Features/containers/Ticket/types";
import { ITicketDescription } from "../../Boards/containers/Tickets/types";

export const effortActualFormInitialState = {
  projectId: "",
  effort: {
    billableHours: false,
    hours: 0,
    minutes: 0,
    date: new Date().toISOString(),
    startTime: new Date().toISOString(),
    endTime: new Date().toISOString(),
  },
};

export const defaultTicketDescription: ITicketDescription = {
  content: "",
  attachments: [],
  attachmentsDetails: [],
  mentionedTicketIds: [],
  mentionedUserIds: [],
  rawContent: "",
};

export const totalEffortInitialState = {
  hours: 0,
  minutes: 0,
};

const defaultTicketDetails: ITicketDetails = {
  _id: "",
  ticketID: "",
  ticketName: "",
  type: "",
  status: "",
  assignedTo: "",
  dueDate: "",
  priority: "",
  effortEstimated: [],
  effortActual: [],
  tags: [],
  description: defaultTicketDescription,
  actionItems: [],
  attachments: [],
  customFields: [],
  release: "",
  sprint: "",
  epic: "",
  environment: "",
  createdBy: "",
  createdDate: "",
  file: [],
  project: {
    _id: "",
    teamId: "",
    name: "",
    isArchived: false,
  },
  team: {
    _id: "",
    teamName: "",
  },
  totalEffortEstimated: totalEffortInitialState,
  totalEffortActual: totalEffortInitialState,
  isFavorite: 0,
};

export const ticketDescriptionFormInitialState: ITicketDescriptionForm = {
  description: {
    content: "",
    attachments: [],
    mentionedUserIds: [],
    mentionedTicketIds: [],
    rawContent: "",
  },
  projectId: "",
};

export const initialState: TicketDetailsState = {
  activeDetailsTab: DetailsTabs?.activity,
  details: { loading: false, result: { ...defaultTicketDetails } },
  duplicateAction: { loading: false },
  archiveAction: { loading: false },
  changeTicketNameAction: { loading: false },
  toggleEffortEstimateMenu: false,
  updateEffortEstimatedLoading: false,
  enableTicketDescription: false,
  enableAddNewTemplateForm: false,
  ticketDescriptionForm: ticketDescriptionFormInitialState,
  updateTicketDescriptionLoading: false,
  actionItems: {
    items: [] as TicketActionItem[],
    newItemValue: "",
    editingItemId: null,
    editingValue: "",
    newInlineItemId: null,
  },
  attachmentState: {
    files: [],
    renamingFileId: null,
    renameValue: "",
    renameAttachmentLoading: false,
    showDeleteModal: false,
    fileToDeleteId: null,
    previewFileId: null,
    previewFileIds: null,
    isPreviewOpen: false,
    previewUrlLoading: false,
    textPreview: {
      fileUrl: null,
      content: null,
      isLoading: false,
      hasError: false,
    },
  },
};
